import { render, staticRenderFns } from "./donations.vue?vue&type=template&id=d01250b8&scoped=true&"
import script from "./donations.vue?vue&type=script&lang=js&"
export * from "./donations.vue?vue&type=script&lang=js&"
import style1 from "./donations.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d01250b8",
  null
  
)

export default component.exports